// extracted by mini-css-extract-plugin
module.exports = {"heroDivisor":"hero-home-divisor-module--heroDivisor--1ez7u"};